// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportDesignerAlerts.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import Alert from 'share/components/controls/Izenda.Alert';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { map, assign, isEqual, isEmpty } from 'lodash/fp';
import PropTypes from 'prop-types';
import { observable } from 'mobx';
import AlertDetails from 'logic/models/Izenda.AlertDetails';
import { SHOW_TYPES, DISPLAY_TIME } from 'logic/data/Izenda.AlertConstants';

const AlertItem = observer(function AlertItem(props: {}) {
  const { item, className } = props;

  return (
    <div key={item.message}>
      <span className={className}>{item.message}</span>
      {item.itemErrors ? (
        <ol>
          {map((message: string) => {
            return <li key={message}>{message}</li>;
          }, item.itemErrors)}
        </ol>
      ) : null}
    </div>
  );
});

@observer
export default class ReportDesignerAlerts extends Component {
  @observable showOldAlertDetails: boolean = false;
  savedInfo: AlertDetails = new AlertDetails();

  static propTypes = {
    showType: PropTypes.string,
    alertKey: PropTypes.string,
    message: PropTypes.string,
    errors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    type: PropTypes.string,
    success: PropTypes.bool,
    onDismiss: PropTypes.func
  };

  componentWillReceiveProps(nextProps: {}) {
    const { showType, alertKey, message, success, errors, type } = nextProps;

    if (showType === SHOW_TYPES.ALWAYS) {
      this.savedInfo.set({
        showType,
        key: alertKey,
        message,
        success,
        errors,
        type
      });
    } else if (showType === SHOW_TYPES.RESET) {
      this.savedInfo.reset();
    }

    this.showOldAlertDetails = false;
  }

  onAutoHide = () => {
    if (this.savedInfo.showType === SHOW_TYPES.ALWAYS) {
      this.showOldAlertDetails = true;
    }
  };

  onDismiss = () => {
    this.props.onDismiss && this.props.onDismiss();
  };

  render() {
    const { errors = [], alertType, alertKey, success, showType, message } = this.showOldAlertDetails
      ? this.savedInfo
      : this.props;
    const className = classnames({
      'alert-item-header': errors && errors.length > 1
    });

    let alertProps = {
      type: alertType,
      displayTime: DISPLAY_TIME,
      onAutoHide: this.onAutoHide,
      onDismiss: this.onDismiss,
      dismissible: this.savedInfo.showType === SHOW_TYPES.ALWAYS
    };

    if (isEqual(alertKey, 'report') || showType === SHOW_TYPES.ALWAYS) {
      alertProps = assign({ autoHide: false }, alertProps);
    }

    const alertText = success
      ? !isEmpty(message)
        ? message
        : null
      : !isEmpty(errors)
      ? errors.map((item: {}, index: number) => <AlertItem key={index} item={item} className={className} />)
      : null;

    return (
      <Alert {...alertProps}>
        {alertText}
      </Alert>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Toolbar/Izenda.ReportDesignerAlerts.js